/**
 * ユーティリティ関数
 *
 * 共通で使用するヘルパー関数を定義。
 */

import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

/**
 * Tailwind CSS クラスを条件付きでマージするユーティリティ関数
 *
 * clsx と tailwind-merge を組み合わせて、以下を実現:
 * 1. 条件付きクラス名の適用（clsx）
 * 2. 競合する Tailwind クラスのスマートなマージ（tailwind-merge）
 *
 * Rails で言えば:
 * - view helper の class_names に近い機能
 *
 * @example
 * // 基本的な使い方
 * cn('text-red-500', 'text-blue-500')
 * // => 'text-blue-500' (後者が勝つ)
 *
 * // 条件付きクラス
 * cn('p-4', isActive && 'bg-blue-500', !isActive && 'bg-gray-100')
 * // => isActive が true なら 'p-4 bg-blue-500'
 *
 * // オブジェクト形式
 * cn('base-class', { 'active-class': isActive, 'disabled-class': isDisabled })
 *
 * @param inputs - クラス名、条件式、オブジェクトの配列
 * @returns マージされたクラス名文字列
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
